import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloseFullscreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"close_fullscreen"}/>
}
